import type { FormEvent } from 'react';
import { toast } from 'sonner';
import { useUpdateCandidateProfile } from './useUpdateCandidateProfile';

export function useProfileSubmit(
  onSuccess: () => void
): (e: FormEvent<HTMLFormElement>) => Promise<void> {
  const { updateProfile } = useUpdateCandidateProfile();

  return async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const name = (formData.get('name') as string) || '';
    if (!name.trim()) return;
    try {
      await updateProfile({
        name,
        phone: (formData.get('phone') as string) || undefined,
        country: (formData.get('country') as string) || undefined,
      });
      toast.success('Profile updated');
      onSuccess();
    } catch {
      toast.error('Failed to update profile');
    }
  };
}
